import { jsx as _jsx } from "react/jsx-runtime";
import { TrackingApp } from './App';
import { CustomThemeProvider } from './custom-theme-provider';
export function Tracking() {
  return /*#__PURE__*/_jsx(TrackingApp, {});
}
export function TrackingProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(CustomThemeProvider, {
    children: children
  });
}